import { useCallback, useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { ITEMS_PER_PAGE_OPTIONS } from '../constants/pages';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
export const TieredPricePageSizeSelect = ({
  itemsPerPage,
  setItemsPerPage
}) => {
  const options = useMemo(() => ITEMS_PER_PAGE_OPTIONS.map(itemsPerPageOption => ({
    text: unescapedText('customerDataProperties.tieredPricing.table.pagination.pageCountButton', {
      count: itemsPerPageOption
    }),
    value: itemsPerPageOption
  })), []);
  const onPageSizeChange = useCallback(({
    target: {
      value
    }
  }) => {
    setItemsPerPage(value);
  }, [setItemsPerPage]);
  return /*#__PURE__*/_jsx(Select, {
    "data-test-id": "tiered-price-table-page-size-select",
    buttonUse: "transparent",
    menuWidth: 250,
    onChange: onPageSizeChange,
    options: options,
    value: itemsPerPage,
    paddingBlock: "200"
  });
};